<dx-popup
  [width]="500"
  [height]="400"
  [showTitle]="true"
  title="Kreiraj otkupne cijene"
  [(visible)]="isVisible"
  [dragEnabled]="false"
  [closeOnOutsideClick]="false"
  (onHiding)="onPopupHiding()"
  (onShown)="onPopupShown()">

  <div *dxTemplate="let options of 'content'" class="popup-content-wrapper">
    <div class="form-container">
      <dx-form
        [formData]="otkupneCijeneForm.value"
        (onFieldDataChanged)="onFieldDataChanged($event)"
        [readOnly]="false"
        [showColonAfterLabel]="true"
        labelLocation="top"
        class="custom-form">
        
        <dxi-item 
          dataField="datum" 
          editorType="dxDateBox" 
          [editorOptions]="datumEditorOptions"
          label="Datum">
          <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-item>
        
        <dxi-item 
          dataField="tekst" 
          editorType="dxTextArea" 
          [editorOptions]="tekstEditorOptions"
          label="Tekst">
          <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-item>

      </dx-form>

      <!-- Form Actions -->
      <div class="form-actions">
        <dx-button
          text="Otkaži"
          stylingMode="contained"
          type="default"
          (onClick)="onCancel()"
          class="action-button">
        </dx-button>
        
        <dx-button
          text="Kreiraj otkupne cijene"
          stylingMode="contained"
          type="default"
          [disabled]="!otkupneCijeneForm.valid"
          (onClick)="onSubmit()"
          class="action-button">
        </dx-button>
      </div>
    </div>
  </div>
</dx-popup>

<dx-load-panel
  [visible]="loading"
  [showPane]="true"
  [shading]="true"
  shadingColor="rgba(0, 0, 0, 0.4)">
</dx-load-panel>